/*jshint esversion: 6 */
/*jshint sub:true*/
import axios from 'axios';
import {extractErrorDetails, getHumanReadableKeys} from '@/helpers/util.js';

const initialState = () => ({
  error: '',
  loading: false,
  project_stats: [],
  workbench_stats: [],
  community_stats: [],
  user_stats: [],
  user_hist_stats: [],
  project_hist_stats: [],
  sequence_hist_stats: [],
  workpackage_hist_stats: [],
  mcallbacks_hist_stats: [],
  mcustomerrequests_hist_stats: [],
});

// State object
const state = initialState();
// Getter functions
const getters = {
  getError: (state) => state.error,
  getProjectStats: (state) => state.project_stats,
  getWorkbenchStats: (state) => state.workbench_stats,
  getCommunityStats: (state) => state.community_stats,
  getUserStats: (state) => state.user_stats,
  getHistUserStats: (state) => state.user_hist_stats,
  getHistProjectStats: (state) => state.project_hist_stats,
  getHistSequenceStats: (state) => state.sequence_hist_stats,
  getHistWorkpackageStats: (state) => state.workpackage_hist_stats,
  getMCallbacksStats: (state) => state.mcallbacks_hist_stats,
  getMCustomerRequestStats: (state) => state.mcustomerrequests_hist_stats,
  isLoading: (state) => state.loading
};
// Actions
const actions = {
  requestStats({commit}, payload) {
      return new Promise((resolve, reject) => {
        commit('set_loading', true);
        // Promise.all([
          axios({
            url: payload.url,
            method: 'GET',
            headers: { 'Cache-Control': 'no-cache' }
          })
          // axios({
          //   url: 'hist/userstats',
          //   method: 'GET',
          //   headers: { 'Cache-Control': 'no-cache' }
          // })
          // axios({
          //   url: 'hist/projectstats',
          //   method: 'GET',
          //   headers: { 'Cache-Control': 'no-cache' }
          // }),
          // axios({
          //   url: 'hist/sequencestats',
          //   method: 'GET',
          //   headers: { 'Cache-Control': 'no-cache' }
          // }),
          // axios({
          //   url: 'hist/workpackagestats',
          //   method: 'GET',
          //   headers: { 'Cache-Control': 'no-cache' }
          // }),
          // axios({
          //   url: 'stats/mcallbacks',
          //   method: 'GET',
          //   headers: { 'Cache-Control': 'no-cache' }
          // }),
          // axios({
          //   url: 'stats/mcustomerrequests',
          //   method: 'GET',
          //   headers: { 'Cache-Control': 'no-cache' }
          // })
        // ])
        .then(resp => {
            commit(payload.mutation, resp.data.data);
            // commit('set_user_hist_stats', resp[0].data.data);
            // commit('set_project_hist_stats', resp[1].data.data);
            // commit('set_sequence_hist_stats', resp[2].data.data);
            // commit('set_workpackage_hist_stats', resp[3].data.data);
            // commit('set_mcallbacks_stats', resp[4].data.data);
            // commit('set_mcustomerrequests_stats', resp[5].data.data);
            commit('set_loading', false);
            resolve();
        })
        .catch(err => {
          commit('set_error', extractErrorDetails(err));
          commit('set_loading', false);
          reject();
        });

      });
    }
};
// Mutations
const mutations = {
  reset(state) {
    const newState = initialState();
    Object.keys(newState).forEach(key => {
      state[key] = newState[key];
    });
  },
  set_error(state, err){
    state.error = err;
  },
  set_loading(state, loading){
    state.loading = loading;
  },
  set_project_stats(state, project_stats){
    state.project_stats = [];
    for(let key of Object.keys(project_stats)){
      state.project_stats.push({
        label: key.replace(/_/g, ' ').toUpperCase(),
        labels: getHumanReadableKeys(project_stats[key].stats),
        type: project_stats[key].type,
        stats: project_stats[key].stats
      });
    }
  },
  set_workbench_stats(state, workbench_stats){
    state.workbench_stats = [];
    for(let key of Object.keys(workbench_stats)){
      state.workbench_stats.push({
        label: key.replace(/_/g, ' ').toUpperCase(),
        labels: getHumanReadableKeys(workbench_stats[key].stats),
        type: workbench_stats[key].type,
        stats: workbench_stats[key].stats
      });
    }
  },
  set_community_stats(state, community_stats){
    state.community_stats = [];
    for(let key of Object.keys(community_stats)){
      state.community_stats.push({
        label: key.replace(/_/g, ' ').toUpperCase(),
        labels: getHumanReadableKeys(community_stats[key].stats),
        type: community_stats[key].type,
        stats: community_stats[key].stats
      });
    }
  },
  set_user_stats(state, user_stats){
    state.user_stats = [];
    for(let key of Object.keys(user_stats)){
      state.user_stats.push({
        label: key.replace(/_/g, ' ').toUpperCase(),
        labels: getHumanReadableKeys(user_stats[key].stats),
        type: user_stats[key].type,
        stats: user_stats[key].stats
      });
    }
  },
  set_user_hist_stats(state, user_stats){
    state.user_hist_stats = [];
    let labels = user_stats.labels;
    for(let key of Object.keys(user_stats)){
      if (key !== 'labels') {
        state.user_hist_stats.push({
          labels: labels,
          label: key.replace(/_/g, ' ').toUpperCase() + '.user',
          stats: user_stats[key]
        });
      }
    }
  },
  set_project_hist_stats(state, project_stats){
    state.project_hist_stats = [];
    let labels = project_stats.labels;
    for(let key of Object.keys(project_stats)){
      if (key !== 'labels') {
        state.project_hist_stats.push({
          labels: labels,
          label: key.replace(/_/g, ' ').toUpperCase() + '.project',
          stats: project_stats[key]
        });
      }
    }
  },
  set_sequence_hist_stats(state, sequence_stats){
    state.sequence_hist_stats = [];
    let labels = sequence_stats.labels;
    for(let key of Object.keys(sequence_stats)){
      if (key !== 'labels') {
        state.sequence_hist_stats.push({
          labels: labels,
          label: key.replace(/_/g, ' ').toUpperCase() + '.sequence',
          stats: sequence_stats[key]
        });
      }
    }
  },
  set_workpackage_hist_stats(state, workpackage_stats){
    state.workpackage_hist_stats = [];
    let labels = workpackage_stats.labels;
    for(let key of Object.keys(workpackage_stats)){
      if (key !== 'labels') {
        state.workpackage_hist_stats.push({
          labels: labels,
          label: key.replace(/_/g, ' ').toUpperCase() + '.workpackage',
          stats: workpackage_stats[key]
        });
      }
    }
  },
  set_mcallbacks_stats(state, mcallbacks_stats){
    state.mcallbacks_hist_stats = [];
    let labels = mcallbacks_stats.labels;
    for(let key of Object.keys(mcallbacks_stats)){
      if (key !== 'labels') {
        state.mcallbacks_hist_stats.push({
          labels: labels,
          label: key.replace(/_/g, ' ').toUpperCase() + '.mcallbacks',
          stats: mcallbacks_stats[key]
        });
      }
    }
  },
  set_mcustomerrequests_stats(state, mcustomerrequests_stats){
    state.mcustomerrequests_hist_stats = [];
    let labels = mcustomerrequests_stats.labels;
    for(let key of Object.keys(mcustomerrequests_stats)){
      if (key !== 'labels') {
        state.mcustomerrequests_hist_stats.push({
          labels: labels,
          label: key.replace(/_/g, ' ').toUpperCase() + '.mcustomerrequests',
          stats: mcustomerrequests_stats[key]
        });
      }
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
